module.exports = __webpack_public_path__ + "assets/img/serve1.3e699031.png";